import { QueryKeys } from '../../../queryKeys';
import { getRequest } from '../../../helpers/apiClient';
import apiRoutes from '../../../api-routes';
import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

export const useDailyReport = (options) => {
  return useQueryWithLogout(
    [QueryKeys.SINGLE_DOCUMENT, options.id],
    async () => {
      const { data } = await getRequest({
        url: apiRoutes.SINGLE_DOCUMENT.replace('{id}', options?.id),
      });

      return data;
    },
    options,
  );
};
